export default __webpack_public_path__ + "static/media/UK01.29d61e12.mp3";